<template>
  <div id="roadRescueFund">
    <div class="query-form">
      <el-form :inline="true" :model="queryParams" ref="queryParams"
               @submit.native.prevent @keyup.enter.native="search">
        <el-form-item label="案件号" prop="caseId" label-width="80px">
          <el-input v-model="queryParams.caseId" clearable placeholder="请输入案件号"
                    size="small" clearable style="width: 200px"/>
        </el-form-item>
        <el-form-item label="费用类型" prop="applyFeeType" label-width="80px">
          <el-select class="select-item" v-model="queryParams.applyFeeType" placeholder="请选择" clearable size="small">
            <el-option v-for="(value,key) in dictMap.road_rescue_apply_fee_type" :key="key" :label="value"
                       :value="key"/>
          </el-select>
        </el-form-item>
        <el-form-item label="受害人联系方式" prop="shrPhone" label-width="130px">
          <el-input v-model="queryParams.shrPhone" clearable placeholder="请输入受害人联系方式"
                    size="small" clearable style="width: 200px"/>
        </el-form-item>
        <el-form-item label="受害人姓名" prop="shrName" label-width="110px">
          <el-input v-model="queryParams.shrName" clearable placeholder="请输入受害人姓名"
                    size="small" clearable style="width: 200px"/>
        </el-form-item>
        <el-form-item label="经办人联系方式" prop="sqjbrPhone" label-width="130px">
          <el-input v-model="queryParams.sqjbrPhone" clearable placeholder="请输入经办人联系方式"
                    size="small" clearable style="width: 200px"/>
        </el-form-item>
        <el-form-item label="经办人姓名" prop="sqjbrName" label-width="100px">
          <el-input v-model="queryParams.sqjbrName" clearable placeholder="请输入经办人姓名"
                    size="small" clearable style="width: 200px"/>
        </el-form-item>
        <el-form-item>
          <el-form-item label="选择日期" prop="dateRange" label-width="80px">
            <el-date-picker class="date-picker" v-model="queryParams.dateRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 240px"
                            clearable value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
          <el-button type="primary" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-content">
      <el-table v-loading="loading" :data="tableData">
        <el-table-column type="index" label="序号" align="center" width="50"/>
        <el-table-column label="案件号" prop="caseId" align="center" width="170"/>
        <el-table-column label="费用类型" prop="applyFeeType" align="center" width="120"
                         :formatter="({ applyFeeType }) => dictMap.road_rescue_apply_fee_type[applyFeeType]"/>
        <el-table-column label="受害人姓名" prop="shrName" align="center" width="90"/>
        <el-table-column label="受害人联系方式" prop="shrPhone" align="center" width="120"/>
        <el-table-column label="申请经办人姓名" prop="sqjbrName" align="center" width="120"/>
        <el-table-column label="申请经办人联系方式" prop="sqjbrPhone" align="center" width="150"/>
        <el-table-column label="医疗/殡葬机构" prop="entName" align="center" width="200" :show-overflow-tooltip="true"/>
        <el-table-column label="申请时间" prop="createTime" align="center" width="150"/>
        <el-table-column align="center" class-name="small-padding fixed-width" label="操作" width="150">
          <template v-slot="scope">
            <el-button size="mini" type="text" @click="queryDetails(scope.row)">申请明细</el-button>
            <el-button size="mini" type="text" @click="queryStatus(scope.row)">案件状态</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination class="pagination-class" v-show="pageInfo.total>0" :limit.sync="pageInfo.pageSize"
                  :page.sync="pageInfo.pageIndex"
                  :total="pageInfo.total" @pagination="getList"/>
    </div>
    <road-rescue-fund-detail v-if="detailOpen" :open="detailOpen" @close="closeDetails"
                             :case-id="currentCaseId" :dict-map="dictMap"/>
    <road-rescue-fund-status v-if="statusOpen" :open="statusOpen" @close="closeStatus"
                             :case-id="currentCaseId"/>
  </div>
</template>

<script>
import {getDictMap} from '@/utils/dict/dictData';
import {getApplyList} from "@/api/rescue/roadRescue";
import RoadRescueFundDetail from "@/views/rescue/RoadRescueFundDetail";
import RoadRescueFundStatus from "@/views/rescue/RoadRescueFundStatus";

export default {
  name: 'RoadRescueFund',
  components: {RoadRescueFundDetail, RoadRescueFundStatus},
  data() {
    return {
      loading: true,
      dictMap: {
        road_rescue_apply_fee_type: {},
        road_rescue_shr_credentials_type: {},
        road_rescue_sqjbr_credentials_type: {},
        road_rescue_shr_relationship_type: {}
      },
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        caseId: '',
        sqjbrPhone: '',
        sqjbrName: '',
        shrPhone: '',
        shrName: '',
        applyFeeType: '',
        dateRange: [],
        beginTime: '',
        endTime: '',
      },
      pageInfo: {
        total: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      currentCaseId: '',
      detailOpen: false,
      statusOpen: false,
    }
  },
  created() {
    this.reset();
    this.getList();
    getDictMap(this.dictMap).then(data => {
      this.dictMap = data;
    });
  }
  ,
  methods: {
    search() {
      this.pageInfo.pageIndex = 1;
      this.getList();
    },
    reset() {
      this.resetForm('queryParams');
    }
    ,
    getList() {
      this.loading = true;
      let dateRange = this.queryParams.dateRange;
      if (null != dateRange && '' !== dateRange) {
        this.queryParams.beginTime = dateRange[0];
        this.queryParams.endTime = dateRange[1];
      } else {
        this.queryParams.beginTime = '';
        this.queryParams.endTime = '';
      }
      getApplyList(this.queryParams, this.pageInfo).then(response => {
          this.tableData = response.data.list;
          this.pageInfo.total = response.data.total;
          this.loading = false;
        }
      );
    }
    ,
    queryDetails(row) {
      this.currentCaseId = row.caseId;
      this.detailOpen = true;
    }
    ,
    closeDetails(data) {
      this.detailOpen = data.open;
    }
    ,
    queryStatus(row) {
      this.currentCaseId = row.caseId;
      this.statusOpen = true;
    }
    ,
    closeStatus(data) {
      this.statusOpen = data.open;
    }
    ,
  }
  ,

}
</script>

<style lang="less">
#roadRescueFund {
  .query-form {
    margin-top: 10px;

    .select-item {
      width: 150px;
    }

    .date-picker .el-range-separator {
      color: #17ECFE;
    }

    .el-range-editor .el-range-input {
      color: #b1e3ff;
    }
  }

  .pagination-container {
    margin-top: -20px;
    margin-bottom: 40px;
    padding: 0;
  }
}
</style>
